export enum RoleActions {
    ConfigureRole = "Configure ",
    CopyRole = "Copy ",
    DeleteRole = "Delete ",
    DeactivateRole = "Deactivate ",
    ReactivateRole = "Reactivate ",
}
